module.exports = __webpack_public_path__ + "static/media/Playstore button.6cc386d3.webp";